import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { importSpreadsheetInterface } from 'src/app/util/interfaces/importSpreadsheetInterface';
import { CmdbLoadService } from './service/cmdb-load.service';
import * as XLSX from 'xlsx';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-cmdb-load',
	templateUrl: './cmdb-load.component.html',
	styleUrls: ['./cmdb-load.component.scss'],
})
export class CmdbLoadComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_acao_demorada: '',
		lbl_geral_baixar_template: '',
		lbl_carga_executada_sucesso: '',
		lbl_nao_foi_possivel_executar_carga_por_erro_na_carga: '',
		lbl_legenda_de_itens_cmdb: '',
		lbl_an_errour_occour: '',
	};

	constructor(
		private CmdbLoadService: CmdbLoadService,
		private NotificationService: NotificationService,
		private ExcelService: ExcelService,
		private LabelsService: LabelsService
	) {}

	isLoadingLabels = true;
	isDownloadingTemplate = false;
	isDownloadingItemTemplate = false;
	isUploadingLoad = false;

	cleanFile = false;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
	}

	loadCMDB(excelData: importSpreadsheetInterface): void {
		excelData = this.cleanEmptySheets(excelData);
		this.isUploadingLoad = true;
		this.CmdbLoadService.postCmdbLoad(excelData).subscribe(
			(res) => {
				if (res.message != 'OK') {
					const responseMessage = JSON.parse(res.message);
					if (responseMessage && responseMessage.length > 0) {
						const templateLabel = '' + this.labels.lbl_nao_foi_possivel_executar_carga_por_erro_na_carga;
						this.NotificationService.setNotificationMessage(
							templateLabel.replace('§item_campo§', JSON.stringify(responseMessage))
						);
						this.cleanFile = true;
						setTimeout(() => {
							this.cleanFile = false;
						}, 10);
					}
					return;
				}

				this.isUploadingLoad = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_carga_executada_sucesso);
				this.cleanFile = true;
				setTimeout(() => {
					this.cleanFile = false;
				}, 10);
			},
			() => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
				this.isUploadingLoad = false;
				this.cleanFile = true;
				setTimeout(() => {
					this.cleanFile = false;
				}, 10);
			}
		);
	}

	cleanEmptySheets(excelData: any): any {
		for (let index = 0; index < Object.keys(excelData.sheets).length; index++) {
			const objectKeyName = Object.keys(excelData.sheets)[index];
			if (!excelData.sheets[objectKeyName].data || excelData.sheets[objectKeyName].data.length === 0) {
				excelData.sheetNameList.splice(index, 1);
				delete excelData.sheets[objectKeyName];
				index--;
			}
		}

		return excelData;
	}

	downloadTemplate(): void {
		if (this.isDownloadingTemplate) return;

		this.NotificationService.setNotificationMessage(this.labels.lbl_acao_demorada);
		this.isDownloadingTemplate = true;
		this.CmdbLoadService.getExcelTemplate().subscribe(
			(templateData) => {
				const workbook: XLSX.WorkBook = { Sheets: {}, SheetNames: templateData.sheets };

				for (const [index, sheetName] of templateData.sheets.entries()) {
					const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], { header: templateData['header'][index] });
					workbook.Sheets[sheetName] = worksheet;
				}

				const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
				this.ExcelService.saveAsExcelFile(excelBuffer, 'loadCMDB');
				this.isDownloadingTemplate = false;
			},
			() => {
				this.isDownloadingTemplate = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
			}
		);
	}

	downloadItemsTemplate(): void {
		if (this.isDownloadingItemTemplate) return;

		this.NotificationService.setNotificationMessage(this.labels.lbl_acao_demorada);
		this.isDownloadingItemTemplate = true;
		this.CmdbLoadService.getExcelItemTemplate().subscribe(
			(templateData) => {
				const workbook: XLSX.WorkBook = { Sheets: {}, SheetNames: templateData.sheets };

				for (const [index, sheetName] of templateData.sheets.entries()) {
					const worksheet = XLSX.utils.aoa_to_sheet(templateData.data[index] ? templateData.data[index] : []);
					workbook.Sheets[sheetName] = worksheet;
				}

				const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
				this.ExcelService.saveAsExcelFile(excelBuffer, 'itemsCMDB');
				this.isDownloadingItemTemplate = false;
			},
			() => {
				this.isDownloadingTemplate = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
			}
		);
	}
}
